<body class="padding">
  <div id="upload_ecms">
    <ng-container *ngIf="!failFlag; then noError; else isError"></ng-container>
  </div>
</body>

<ng-template #noError>
  <ng-container *ngIf="!isUploading; then isUpload; else isSpinner"></ng-container>
</ng-template>

<ng-template #isError>
  <h2>Error uploading file!</h2>
  <span class="hubid">Please contact support</span>
</ng-template>

<ng-template #isUpload>
  <div class="editrow">
    <br />
    <label for="dispatched" class="left">Enter ECMS data: </label>
    <br />
    <div class="field-header">Enter Ecms Status</div>
    <br />
    <mat-form-field>
      <mat-select [(ngModel)]="newECMS.ecms_status_id" placeholder="Select">
        <mat-option *ngFor="let status of ecmsStatusList" [value]="status.ecms_status_id">{{ status.ecms_status_text }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <br />
    <div class="field-header">Hub Batch Number</div>
    <br />
    <mat-form-field>
      <input placeholder="enter hub batch number" matInput [(ngModel)]="newECMS.hub_batch" />
    </mat-form-field>
    <br />
    <div class="field-header">EI Batch Number</div>
    <br />
    <mat-form-field>
      <input placeholder="enter ei batch number" matInput [(ngModel)]="newECMS.ei_batch" />
    </mat-form-field>
    <br />
    <div class="field-header">Date Sent</div>
    <br />
    <mat-form-field>
      <input placeholder="e.g. 2019-12-28" matInput [(ngModel)]="newECMS.date_sent" />
    </mat-form-field>
    <br />
    <div class="field-header">Comment</div>
    <br />
    <mat-form-field>
      <textarea matInput [(ngModel)]="newECMS.comment" cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
        placeholder="enter comment"></textarea>
    </mat-form-field>
    <br />
    <div class="field-header">Enter MPRNs</div>
    <br />
    <mat-form-field>
      <textarea matInput [(ngModel)]="newECMS.mprn" cdkTextareaAutosize cdkAutosizeMinRows="6" cdkAutosizeMaxRows="6"
        placeholder="seperate by ,"></textarea>
    </mat-form-field>
  </div>
  <div class="panel">
    <button mat-raised-button color="primary" id="upload_ecms" (click)="upload()"
      [disabled]="isDisabled">Update</button>
  </div>
  <div class="panel">
    <button mat-raised-button color="primary" id="upload_close" (click)="cancel()"
      [disabled]="isDisabled">Cancel</button>
  </div>
</ng-template>

<ng-template #isSpinner>
  <div class="uploader-status">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
